import React from 'react';
import { Box, IconButton, Modal, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import uberEatsLogo from "../images/ubereats-logo.png";
import skipTheDishesLogo from "../images/skipthedishes-logo.svg";
import doordashLogo from "../images/doordash-logo.jpeg";
import business from "../data/business.json";

const logos = {
  "Uber Eats": uberEatsLogo,
  "SkipTheDishes": skipTheDishesLogo,
  "DoorDash": doordashLogo,
};

const modalStyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 'calc(100% - 32px)',
  maxWidth: 480,
  maxHeight: 'calc(100% - 32px)',
  overflowY: 'auto',
  bgcolor: 'background.paper',
  border: '2px solid #000',
  borderRadius: '12px',
  boxShadow: 24,
  p: { xs: 3, sm: 4 },
  textAlign: 'center',
};

const groupTitleStyle = {
  fontWeight: 600,
  color: "#212529",
  letterSpacing: "0.1em",
  fontSize: "0.9rem",
  margin: "1.5em 0 0.75em",
};

const optionStyle = {
  display: "flex",
  alignItems: "center",
  gap: "16px",
  minHeight: 64,
  padding: "8px 16px",
  marginBottom: "10px",
  border: "2px solid #e6e6e6",
  borderRadius: "12px",
  color: "#212529",
  textAlign: "left",
  textDecoration: "none",
};

const OrderOption = ({ service, method, url }) => (
  <a
    href={url}
    target="_blank"
    rel="noopener noreferrer"
    className="order-option"
    style={optionStyle}
  >
    <span style={{ width: 96, flexShrink: 0, display: "flex", justifyContent: "center" }}>
      <img src={logos[service]} alt="" style={{ maxWidth: "100%", maxHeight: 40 }} />
    </span>
    <span style={{ flexGrow: 1, lineHeight: 1.3 }}>
      <strong style={{ display: "block", fontSize: "1.05rem" }}>{service}</strong>
      <span style={{ fontSize: "0.9rem", color: "#555" }}>{method}</span>
      <span className="sr-only"> (opens {service} in a new tab)</span>
    </span>
    <OpenInNewIcon aria-hidden="true" style={{ color: "#EC9524" }} />
  </a>
);

const Order = (props) => {
  const delivery = business.ordering.filter(option => option.method === "Delivery");
  const pickup = business.ordering.filter(option => option.method === "Pickup");

  return (
    <Modal
      open={props.modalOpen}
      onClose={props.handleClose}
      aria-labelledby="order-modal-title"
      aria-describedby="order-modal-description"
    >
      <Box sx={modalStyle}>
        <IconButton
          onClick={props.handleClose}
          aria-label="Close"
          sx={{ position: 'absolute', top: 8, right: 8 }}
        >
          <CloseIcon />
        </IconButton>
        <Typography id="order-modal-title" variant="h6" component="h2" style={{ fontWeight: 600, color: "#EC9524", letterSpacing: "0.05em" }}>
          ORDER NOW
        </Typography>
        <Typography id="order-modal-description" variant="body2" style={{ color: "#555", marginTop: "0.5em" }}>
          Choose an app below. You'll finish your order with that service.
        </Typography>

        <Typography variant="h6" component="h3" style={groupTitleStyle}>
          DELIVERY
        </Typography>
        {delivery.map(option => <OrderOption key={option.url} {...option} />)}

        <Typography variant="h6" component="h3" style={groupTitleStyle}>
          PICKUP
        </Typography>
        {pickup.map(option => <OrderOption key={option.url} {...option} />)}

        <Typography variant="body2" style={{ color: "#555", marginTop: "1em" }}>
          Or just walk up to our window at {business.address.streetAddress}. The entrance is around the corner on Foxley Street.
        </Typography>
      </Box>
    </Modal>
  )
}

export default Order;
